import React from "react";
import PropTypes from "prop-types";
import StickyNoteWidget from "./StickyNoteWidget";

let StickyNoteWidgetContainer =
    ({
         configs = {},
         isEditMode = false,
         isDashboardFullScreen = false,
         onRefreshClicked = () => {},
         onForceUpdateClick = () => {},
         onEditClick = () => {},
         onCreateClick = () => {},
         onDuplicateClicked = () => {},
         onDeleteClicked = () => {},
     }) => {
        let bgColorClass = configs.bgColorClass ? configs.bgColorClass : 'bgc-stickyNote';
        return (
            <StickyNoteWidget
                widgetDisplayName={configs.widgetDisplayName}
                text={configs.text}
                bgColorClass={bgColorClass}
                customStyle={configs.customStyle}
                isEditMode={isEditMode}
                isDashboardFullScreen={isDashboardFullScreen}
                onForceUpdateClick={onForceUpdateClick}
                onRefreshClicked={onRefreshClicked}
                onEditClick={onEditClick}
                onCreateClick={onCreateClick}
                onDuplicateClicked={onDuplicateClicked}
                onDeleteClicked={onDeleteClicked}
            />
        );
    };

StickyNoteWidgetContainer.propTypes = {
    configs: PropTypes.object,
    isEditMode: PropTypes.bool,
    isDashboardFullScreen: PropTypes.bool,
    onRefreshClicked: PropTypes.func,
    onForceUpdateClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func
};

export default StickyNoteWidgetContainer;
